import { z } from "zod";
import type { OrigemGrupoLogin } from "./loginUnificado.types";
import { obterModoLoginUnificado } from "./utils/usuarioLogin.utils";

// ------------------------------- CONSTANTS -------------------------------
const schemaCredenciais = z.object({
	codigo: z.string(),
	username: z.string().trim().min(1, "Digite seu usuário, ID ou CPF."),
	password: z.string(),
});

export const VALORES_PADRAO_LOGIN_UNIFICADO = { codigo: "", username: "", password: "" };

// --------------------------------- TYPES ---------------------------------
export type FormularioLoginUnificado = z.infer<typeof schemaCredenciais>;

// ------------------------------- FUNCTIONS -------------------------------
export function criarSchemaLoginUnificado(origem: OrigemGrupoLogin) {
	return schemaCredenciais.superRefine((dados, contexto) => {
		if (obterModoLoginUnificado(dados.username) === "senha" && dados.password.length === 0)
			contexto.addIssue({
				code: z.ZodIssueCode.custom,
				path: ["password"],
				message: "Digite sua senha.",
			});
		if (origem === "codigo" && !/^\d{4}$/.test(dados.codigo))
			contexto.addIssue({
				code: z.ZodIssueCode.custom,
				path: ["codigo"],
				message: "Informe os 4 dígitos do grupo.",
			});
	});
}
